import { exportData, getApiTargetInfo, getEventTypes, getUnits } from 'core'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
// import Wind2CommonUpdateHandler from './Wind2CommonUpdateHandler'
import { Button, Icon, Upload, message } from 'antd'
import { Content, CriteriaRow, Label, Title } from 'core/screen-util'
import {
  getAuthorization,
  getCredentials,
  getSystemConfigurationInfo,
} from 'api/pgads'

import { ErrorContext, SpinContext } from 'context'
import {
  JcTmpErrorTable,
  isErrorContainsTmpError,
} from 'core/component/JcTmpErrorDialog'

const WIND2_IMPORT_NERC_EVENT = 'WIND2_IMPORT_NERC_EVENT'
const WIND2_IMPORT_NERC_PERFORMANCE = 'WIND2_IMPORT_NERC_PERFORMANCE'
const WIND2_IMPORT_TURBINE_EVENT = 'WIND2_IMPORT_TURBINE_EVENT'
const WIND2_IMPORT_TURBINE_PERFORMANCE = 'WIND2_IMPORT_TURBINE_PERFORMANCE'

const Wind2ImportFileOnly = ({ targetInfo }) => {
  const { setSpinning } = useContext(SpinContext)
  const [tmpData, setTmpData] = useState([])
  const { setError } = useContext(ErrorContext)

  const [systemConfig, setSystemConfig] = useState([])

  useEffect(
    _ => {
      getSystemConfigurationInfo(targetInfo).fork(_ => _, setSystemConfig)
    },
    [targetInfo]
  )

  const isAvaliable = useCallback(
    key => {
      const isAval = systemConfig.find(f => f.key === key) || { value: 'N' }

      return isAval.value === 'YES' || isAval.value === 'yes'
    },
    [systemConfig]
  )

  const getUploadComponent = importUrl => {
    const url = _ => `${targetInfo.baseUrl}/wind-nerc-powerdata/${importUrl}`
    const fileProps = {
      name: 'file',
      action: url(),
      method: 'POST',
      headers: getAuthorization(targetInfo),
      ...getCredentials(targetInfo),
    }
    return (
      <Upload
        {...fileProps}
        beforeUpload={_ => setSpinning(false)}
        onChange={data => {
          if (data.file.status === 'uploading') {
            // setSpinning(true)
          } else setSpinning(false)

          if (data.file.status === 'done') {
            const tmpData = data.file.response || []
            setTmpData(tmpData)
            if (!isErrorContainsTmpError(tmpData)) {
              message.success('File imported successfully')
            }
          }
          if (data.file.status === 'error') setError(data.file.response)
          // onFileUploadChange(data)
        }}
        multiple={false}
        showUploadList={false}
      >
        <Button>
          <Icon type="upload" /> Click to Upload
        </Button>
      </Upload>
    )
  }

  const ImportComponent = _ => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto auto',
          gap: 5,
        }}
      >
        {isAvaliable(WIND2_IMPORT_NERC_EVENT) && (
          <React.Fragment>
            <Label>Import NERC Event :</Label>
            <div> {getUploadComponent('import-nerc-event')}</div>
            <Button
              onClick={_ =>
                exportData(
                  new Blob([nercEventSample]),
                  'csv',
                  'NERCEventSample.csv'
                )
              }
              type="link"
            >
              Download Sample File
            </Button>
          </React.Fragment>
        )}

        {isAvaliable(WIND2_IMPORT_TURBINE_EVENT) && (
          <React.Fragment>
            {' '}
            <Label>Import Turbine Event :</Label>
            <div>{getUploadComponent('import-turbine-event')}</div>
            <Button
              onClick={_ =>
                exportData(
                  new Blob([turbineEventSample]),
                  'csv',
                  'TurbineEventSample.csv'
                )
              }
              type="link"
            >
              Download Sample File
            </Button>
          </React.Fragment>
        )}

        {isAvaliable(WIND2_IMPORT_NERC_PERFORMANCE) && (
          <React.Fragment>
            <Label>Import NERC Performance :</Label>
            <div>{getUploadComponent('import-nerc-performance')}</div>
            <Button
              onClick={_ =>
                exportData(
                  new Blob([nercPerformance]),
                  'csv',
                  'NERCPerformanceSample.csv'
                )
              }
              type="link"
            >
              Download Sample File
            </Button>
          </React.Fragment>
        )}

        {isAvaliable(WIND2_IMPORT_TURBINE_PERFORMANCE) && (
          <React.Fragment>
            <Label>Import Turbine Performance :</Label>
            <div>{getUploadComponent('import-turbine-performance')}</div>
            <Button
              onClick={_ =>
                exportData(
                  new Blob([turbinePerformance]),
                  'csv',
                  'TurbinePerformanceSample.csv'
                )
              }
              type="link"
            >
              Download Sample File
            </Button>{' '}
          </React.Fragment>
        )}
      </div>
    )
  }

  return (
    <div>
      <CriteriaRow>
        <Title>Wind Import Data</Title>
      </CriteriaRow>
      <div style={{ marginTop: '5px' }}>
        <CriteriaRow>
          <ImportComponent />
        </CriteriaRow>
      </div>
      <Content>
        <JcTmpErrorTable errors={tmpData} scroll={{ y: 500 }} />
      </Content>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  eventTypesData: getEventTypes(state),
  units: getUnits(state),
})
export default connect(mapStateToProps)(Wind2ImportFileOnly)

const nercEventSample =
  'Entity Id,PlantId,EventId,EventStart,StartZone,EventEnd,EndZone,EventType,CauseCode,ContributingOperatingCondition,PotentialGenerationLoss,Description,CauseCodeExt1,CauseCodeExt2,CauseCodeExt3,CauseCodeExt4,CauseCodeExt5,CauseCodeExt6,CauseCodeExt7,CauseCodeExt8,CauseCodeExt9,CauseCodeExt10,DescriptionExtension\n' +
  'ABC12101,000001,e-1,02/01/2024 01:01,CST,02/02/2024 01:01,CST,FO,17010,0,10,test123desc,1,2,3,4,5,6,7,8,9,10,desc-ext'

const turbineEventSample =
  'EventId,PlantId,TurbineId,EventId,EventStart,StartZone,EventEnd,EndZone,EventType,CauseCode,ContributingOperatingCondition,Description\n' +
  'ABC12101,000001,1531001,t-1,02/01/2024 01:01,CST,02/02/2024 01:01,CST,FO,17010,0,test123'

const nercPerformance =
  'EntityId,PlantId,SubgroupId,Year,Month,Status,GrossActualGeneration,ExpectedGen,NetActGen,NetMaxCap,ActiveThrs,ContactThrs,RSThrs,ForcedThrs,MaintenanceThrs,PlannedThrs,RuThrs,InActiveReserveThrs,MonthballedThrs,RetiredThrs\n' +
  'ABC11780,000003,724,2024,1,AC,200,180,210,1,2,3,4,5,6,7,8,9,10,12'

const turbinePerformance =
  'EntityId,PlantId,TurbineId,Year,Month,Status,GrossActualGeneration,ExpectedGeneration,NetActualGeneration,NetMaxCapacity,ActiveThrs,ContactThrs,RSThrs,ForcedThrs,MaintenanceThrs,PlannedThrs,RUThrs,InActiveReserveThrs,MonthballdThrs,RetiredThrs\n' +
  'ABC11780,000003,724,2024,1,AC,200,180,210,1,2,3,4,5,6,7,8,9,10,13'

/*

delete system_configuration where modulename in ('WIND2_IMPORT_NERC_EVENT','WIND2_IMPORT_NERC_PERFORMANCE','WIND2_IMPORT_TURBINE_EVENT','WIND2_IMPORT_TURBINE_PERFORMANCE');
insert into system_configuration (modulename,description,setting) 
values('WIND2_IMPORT_NERC_EVENT','WInd2 Import NERC Event','YES');
insert into system_configuration (modulename,description,setting) 
values('WIND2_IMPORT_NERC_PERFORMANCE','WInd2 Import NERC Performance','YES');
insert into system_configuration (modulename,description,setting) 
values('WIND2_IMPORT_TURBINE_EVENT','WInd2 Import Turbine Event','YES');
insert into system_configuration (modulename,description,setting) 
values('WIND2_IMPORT_TURBINE_PERFORMANCE','WInd2 Import Turbine Performance','YES');
commit;

*/
